import React from 'react';
import { Card, CardContent } from '@/components/ui/Card';
import { PurchaseOrderMetricsSummary } from '@/types/domain/po-management';
import { ShoppingBag, Clock, AlertTriangle, Truck, Database } from 'lucide-react';

interface PoKpiCardsProps {
  metrics: PurchaseOrderMetricsSummary;
}

export const PoKpiCards: React.FC<PoKpiCardsProps> = ({ metrics }) => {
  const cards = [
    {
      title: 'Total Purchase Orders',
      value: metrics.totalPos,
      icon: ShoppingBag,
      color: 'text-primary bg-primary/10 border-primary/20',
      description: 'Active commercial POs',
    },
    {
      title: 'Open Orders',
      value: metrics.openPos,
      icon: Clock,
      color: 'text-blue-600 bg-blue-500/10 border-blue-500/20',
      description: 'In-flight procurement',
    },
    {
      title: 'Pending Release',
      value: metrics.pendingRelease,
      icon: Clock,
      color: 'text-amber-600 bg-amber-500/10 border-amber-500/20',
      description: 'Awaiting SAP / manager release',
    },
    {
      title: 'Partially Delivered',
      value: metrics.partiallyDelivered,
      icon: Truck,
      color: 'text-purple-600 bg-purple-500/10 border-purple-500/20',
      description: 'Partial GRN received',
    },
    {
      title: 'Delayed POs',
      value: metrics.delayedPos,
      icon: AlertTriangle,
      color: 'text-rose-600 bg-rose-500/10 border-rose-500/20',
      description: 'Overdue delivery milestone',
    },
    {
      title: 'SAP Synced',
      value: metrics.sapSyncedCount,
      icon: Database,
      color: 'text-emerald-600 bg-emerald-500/10 border-emerald-500/20',
      description: 'Synced with SAP ME21N',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3.5 font-poppins">
      {cards.map((c) => {
        const Icon = c.icon;
        return (
          <Card key={c.title} className="border-border rounded-2xl shadow-2xs overflow-hidden">
            <CardContent className="p-3.5 space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-[11px] font-extrabold text-foreground-secondary uppercase tracking-wider">
                  {c.title}
                </span>
                <div className={`p-2 rounded-xl border ${c.color}`}>
                  <Icon className="h-4 w-4" />
                </div>
              </div>

              <div>
                <span className="text-xl font-extrabold text-foreground tracking-tight block">
                  {c.value}
                </span>
                <span className="text-[10px] font-bold text-foreground-muted block mt-0.5">
                  {c.description}
                </span>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
